const LOCAL_STORAGE_TEST_KEY = 'local_storage_test_key';
class StubStorage {
    constructor() {
        this.items = {};
    }
    getItem(key) {
        return this.items[key];
    }
    setItem(key, value) {
        this.items[key] = value;
    }
    removeItem(key) {
        delete this.items[key];
    }
    clear() {
        this.items = {};
    }
}
const isLocalStorageAvailable = () => {
    if (!('localStorage' in window)) {
        return false;
    }
    try {
        localStorage.setItem(LOCAL_STORAGE_TEST_KEY, '');
        localStorage.removeItem(LOCAL_STORAGE_TEST_KEY);
    }
    catch (_a) {
        // Most likely iOS Safari in private browsing mode whereby localStorage is available but errors if you use it
        return false;
    }
    return true;
};
const storage = isLocalStorageAvailable() ? localStorage : new StubStorage();
export const saveToStorage = (key, data) => storage.setItem(key, JSON.stringify(data));
export const getFromStorage = (key) => {
    const content = storage.getItem(key);
    if (!content) {
        return;
    }
    try {
        return JSON.parse(content);
    }
    catch (e) {
        /* eslint-disable-next-line no-console */
        console.warn(`Failed to parse data for key '${key}'`, e);
    }
    return;
};
export const removeFromStorage = (key) => storage.removeItem(key);
export const clearStorage = () => storage.clear();
